import { render, staticRenderFns } from "./DepositReport.vue?vue&type=template&id=2c1d6dc0"
import script from "./DepositReport.vue?vue&type=script&lang=js"
export * from "./DepositReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports